/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Empty_Create_TemplateInputs */

const cs_draft_empty_create_template = /** @type {(inputs: Draft_Empty_Create_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit šablonu`)
};

const en_draft_empty_create_template = /** @type {(inputs: Draft_Empty_Create_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a template`)
};

/**
* | output |
* | --- |
* | "Create a template" |
*
* @param {Draft_Empty_Create_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_empty_create_template = /** @type {((inputs?: Draft_Empty_Create_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Empty_Create_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_empty_create_template(inputs)
	return cs_draft_empty_create_template(inputs)
});